module.exports = __webpack_public_path__ + "media/images/lp-tpe-842f9a45f8bbd9e0556ce8fbb804e386.png";